import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useNotification } from './NotificationContext';

/**
 * Компонент для отображения toast-уведомлений
 * Использует MUI Snackbar для показа уведомлений поверх всего контента
 */
const NotificationToast = () => {
    const { notifications, hideNotification } = useNotification();

    if (notifications.length === 0) {
        return null;
    }

    // Показываем только последнее уведомление
    const currentNotification = notifications[notifications.length - 1];

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        hideNotification(currentNotification.id);
    };

    // Определяем severity для MUI Alert
    const getSeverity = (severity) => {
        switch (severity) {
            case 'error':
                return 'error';
            case 'warning':
                return 'warning';
            case 'info':
                return 'info';
            case 'success':
                return 'success';
            default:
                return 'error';
        }
    };

    return (
        <Snackbar
            open={true}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            sx={{
                zIndex: 100000, // Высокий z-index чтобы быть поверх всего
                '& .MuiSnackbarContent-root': {
                    minWidth: '600px',
                    maxWidth: '1200px'
                }
            }}
        >
            <Alert 
                onClose={handleClose} 
                severity={getSeverity(currentNotification.severity)}
                sx={{
                    width: '100%',
                    py: 2,
                    px: 3,
                    '& .MuiAlert-message': {
                        fontSize: '1.5rem',
                        whiteSpace: 'pre-line', // чтобы \n в тексте отрисовывались
                        lineHeight: 1.4,
                    }
                }}
            >
                {currentNotification.message}
            </Alert>
        </Snackbar>
    );
};

export default NotificationToast;

